import section7 from "./bemasster-grundriss-am-pc.jpg";
import section6 from "./bemasster-grundriss-auf-laptop.jpg";
import section2 from "./bemasster-grundriss-bank-plan.jpg";
import section1 from "./bemasster-grundriss-living-space-table.jpg";
import section5 from "./besprechung-eines-bemassten-grundrisses.jpg";
import section3 from "./entwurf-bemasster-grundriss.webp";
import header from "./nahansicht-bemasster-grundriss.webp";
import section4 from "./zeichnung-eines-bemassten-grundrisses.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
